export enum TipoReceptor {
  BECARIO_NACIONAL = 'BECARIO_NACIONAL',
  PENSIONISTA = 'PENSIONISTA',
}
